//Uhr
export function startTime() {
  var today = new Date();
  var h = today.getHours();
  var m = today.getMinutes();
  var s = today.getSeconds();
  m = checkTime(m);
  s = checkTime(s);
  document.getElementById("clock").innerHTML = h + ":" + m + ":" + s;
  setTimeout(startTime, 1000);
}

// Macht ein 0 wen es nur eine Zahl vorne ist 10:30:50
function checkTime(i) {
  if (i < 10) {
    i = "0" + i;
  }
  return i;
}



// WEBPACK FOOTER //
// ./src/clock.js